export { default } from './CardFrameCollection';
